import { themeI18n } from '../utils/i18n_helper';

import '../../styles/components/badge.scss';

const badgeMetaobjects = JSON.parse(document.querySelector('[data-badge-metaobjects]').innerHTML).badges;

export const Badges = ({ product, promotionBadge, className }) => {
  let transactionalBadge = {};

  if (!product.available) {
    transactionalBadge.status = "sold-out";
    transactionalBadge.text = themeI18n('products.badge.sold_out');
  } else if (product.compare_at_price && product.compare_at_price > product.price) {
    // transactionalBadge.status = "sale";
    // transactionalBadge.text = themeI18n('products.on_sale');
  }

  const productBadges = badgeMetaobjects
  .map((badge) => {
    if (product.tags.includes(badge.tag)) {
      return badge;
    }
    return null; // Explicitly return null for non-matching cases
  })
  .filter((badge) => badge !== null); // Filter out null values

  return (
    <div className={className}>
      {transactionalBadge.status && (
        <div className={`badge text-label--small badge--${transactionalBadge.status}`}>
          {transactionalBadge.text}
        </div>
      )}


      {promotionBadge && promotionBadge?.active === "true" && (
        <div className={`badge text-label--small`} style={{backgroundColor: promotionBadge.background_color, color: promotionBadge.text_color}}>
          {promotionBadge.title}
        </div>
      )}

      {productBadges.map((badge) => (
        <div
          key={badge.id}
          className={`badge text-label--small`}
          style={{backgroundColor: badge.color, color: badge.color_text}}
        >
          {badge.heading}
        </div>
      ))}
    </div>
  )
}
